import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatDateTime, LabelRequest } from './packingApi';
import { badge, btn, num, td, th } from './packingStyles';

interface Props {
  requests: LabelRequest[];
  onPrinted: (request: LabelRequest) => void;
}

/** "Naklejki do druku" for Andrzej: labels missing at packing and surplus pieces. */
const PackingLabelsView: React.FC<Props> = ({ requests, onPrinted }) => {
  const { t } = useLanguage();

  return (
    <>
      <p style={{ margin: '0 0 12px', color: '#475569', fontSize: 14 }}>{t('packing.labels.hint')}</p>
      {requests.length === 0 ? (
        <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>{t('packing.labels.empty')}</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 860 }}>
            <thead>
              <tr>
                <th style={th}>{t('packing.labels.source')}</th>
                {['week', 'line', 'name', 'index', 'ean'].map((k) => (
                  <th key={k} style={th}>{t(`packing.col.${k}`)}</th>
                ))}
                <th style={{ ...th, textAlign: 'right' }}>{t('packing.labels.qty')}</th>
                <th style={th}>{t('packing.labels.requestedBy')}</th>
                <th style={th} />
              </tr>
            </thead>
            <tbody>
              {requests.map((r) => (
                <tr key={r.id}>
                  <td style={td}>
                    {r.source === 'surplus' ? (
                      <span style={badge('#e0e7ff', '#3730a3')}>{t('packing.labels.sourceSurplus')}</span>
                    ) : (
                      <span style={badge('#fef3c7', '#92400e')}>{t('packing.labels.sourceMissing')}</span>
                    )}
                  </td>
                  <td style={td}>{r.row?.tydzien ?? '-'}</td>
                  <td style={td}>{r.row?.linia ?? '-'}</td>
                  <td style={td}>{r.row?.nazwa}</td>
                  <td style={{ ...td, fontFamily: 'monospace' }}>{r.row?.indeks}</td>
                  <td style={{ ...td, fontFamily: 'monospace', fontSize: 13 }}>{r.row?.ean}</td>
                  <td style={{ ...num, fontSize: 18, fontWeight: 800 }}>{r.quantity}</td>
                  <td style={{ ...td, fontSize: 13, color: '#475569' }}>
                    {[r.requested_by, formatDateTime(r.requested_at)].filter(Boolean).join(' · ')}
                  </td>
                  <td style={td}>
                    <button type="button" style={btn('primary')} onClick={() => onPrinted(r)}>
                      {t('packing.labels.printed')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default PackingLabelsView;
